module.exports = __webpack_public_path__ + "static/hero-ogp-9982b308fe874ced4a003d77f4c79abb.png";